import { createSlice } from '@reduxjs/toolkit';

export enum UserTypeVariant {
  Customer = 'Customer',
  Admin = 'Admin',
}

const initialState = {
  user: null,
  userType: null,
  tbRegistrationSuccess: false,
  error: null,
  loading: false,
};

const slice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    userSetDataAction: (state, action) => {
      let userType: any =
        action.payload.user_type === 'Admin'
          ? UserTypeVariant.Admin
          : UserTypeVariant.Customer;
      state.user = action.payload;
      state.userType = userType;
    },
    tbRegistrationAction: state => {
      state.loading = true;
    },
    setTbRegistrationSuccess: state => {
      state.tbRegistrationSuccess = true;
      state.loading = false;
      state.error = null;
    },
    errorUserAction: (state, action) => {
      state.tbRegistrationSuccess = false;
      state.loading = false;
      state.error = action.payload;
    },
    partialUserResetAction: state => {
      state.tbRegistrationSuccess = false;
      state.loading = false;
      state.error = null;
    },
    userResetState: () => initialState,
  },
});

export const {
  userSetDataAction,
  userResetState,
  tbRegistrationAction,
  setTbRegistrationSuccess,
  errorUserAction,
  partialUserResetAction,
} = slice.actions;

export default slice.reducer;
